import { render, staticRenderFns } from "./ExampleVueDataTable.vue?vue&type=template&id=56c17d96&scoped=true"
import script from "./ExampleVueDataTable.vue?vue&type=script&lang=js"
export * from "./ExampleVueDataTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c17d96",
  null
  
)

export default component.exports